export default "/fonts/vendor/fontsource-roboto/files/roboto-cyrillic-400-normal.woff2?3605d18d8a4ce5bd39c3d32119574854";